import { RouterItem } from '@/utils/interfaces';

import systemManageRoutes from './system-manage-route';
import topRoutes from './top-route';

/** 所有动态路由 */
const routes = [...topRoutes, ...systemManageRoutes];

export default routes;
